/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

function InputSelect({
  name,
  label,
  value = '',
  values,
  onChange,
  formStyle = { width: '100%' },
  selectStyle = { width: '100%' },
  disabled = false,
  hideEmpty = false,
  emptyLabel = 'Selecione',
  emptyValue = '',
  margin = 'dense',
  required = false,
  error = '',
  helperText = '',
}) {
  return (
    <FormControl
      required={required}
      fullWidth
      variant='outlined'
      margin={margin}
      size='small'
      disabled={disabled}
      sx={formStyle}
      error={error}
      helperText={helperText}>
      <InputLabel
        id={`${name}-label`}
        shrink
        sx={{ backgroundColor: 'white', padding: '0 5px' }}>
        {label}
      </InputLabel>
      <Select
        displayEmpty
        labelId={`${name}-label`}
        id={`${name}`}
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        InputLabelProps={{ shrink: true }}
        margin='dense'
        variant='outlined'
        renderValue={(selected) => {
          if (!values || values.length === 0) return emptyLabel;
          const option = values.find((v) => String(v.value) === String(selected));
          return option?.label ?? emptyLabel;
        }}
        sx={selectStyle}>
        {!hideEmpty && <MenuItem value={emptyValue}>{emptyLabel}</MenuItem>}
        {values.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled || false}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default InputSelect;
